goog.provide("shadow.js.shim.module$src$svg$artwork$masonry_svg$default");
shadow.js.shim.module$src$svg$artwork$masonry_svg$default = shadow.js.shim.module$src$svg$artwork$masonry_svg.default;
